var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "i-cart",
    width: "18px",
    height: "18px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shops"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.92,24.08l-2.24-13A4.73,4.73,0,0,0,21.14,7H21A5,5,0,0,0,11,7h-.14a4.73,4.73,0,0,0-4.54,4.08l-2.24,13a5.23,5.23,0,0,0,1.13,          4.29A4.45,4.45,0,0,0,8.62,30H23.38a4.45,4.45,0,0,0,3.41-1.63A5.23,5.23,0,0,0,27.92,24.08ZM16,4a3,3,0,0,1,3,3H13A3,3,0,0,1,16,          4Zm9.26,23.08a2.45,2.45,0,0,1-1.88.92H8.62a2.45,2.45,0,0,1-1.88-.92,3.21,3.21,0,0,1-.69-2.66l2.24-13A2.74,2.74,   0,0,1,10.86,9H21.14a2.74,2.74,0,0,1,2.57,2.42l2.24,13A3.21,3.21,0,0,1,25.26,27.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCart);
export default __webpack_public_path__ + "static/media/add-cart.07089cca7ace32a4716dc122b1b11a68.svg";
export { ForwardRef as ReactComponent };